function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable @typescript-eslint/no-use-before-define */
// Refer to https://github.com/aws/aws-sdk-js-v3/blob/main/packages/hash-node/src/index.ts to create browser implementation

/**
 * To require this module explicitly, use require('buffer/') which tells the node.js module lookup algorithm
 * (also used by browserify) to use the npm module named buffer instead of the node.js core module named buffer
 */
import { Buffer } from 'buffer/';
import hex from 'crypto-js/enc-hex';
import hmacSHA256 from 'crypto-js/hmac-sha256';
import WordArray from 'crypto-js/lib-typedarrays';
import sha256 from 'crypto-js/sha256';

// Converts a byte array to an array of 32 bit words for consumption by CryptoJS
function toWordArray(u8arr) {
  const words = [];
  for (let i = 0; i < u8arr.length; i++) {
    // eslint-disable-next-line no-bitwise
    words[i >> 2] |= (u8arr[i] & 0xff) << (3 - (i & 3) << 3);
  }
  return WordArray.create(words, u8arr.length);
}
export class CryptoHash {
  constructor(secret) {
    _defineProperty(this, "secret", void 0);
    _defineProperty(this, "encoding", void 0);
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "secretProvidedIsNotString", false);
    if (secret) {
      if (typeof secret === 'string') {
        this.secret = secret;
      } else {
        this.secret = castSourceData(secret).toString('hex');
        this.secretProvidedIsNotString = true;
      }
    }
  }
  update(toHash, encoding) {
    this.encoding = encoding;
    this.data = toHash;
  }
  async digest() {
    if (typeof this.data !== 'string' && !(this.data instanceof Uint8Array)) {
      throw Error('not supported');
    }
    const data = this.data instanceof Uint8Array ? toWordArray(this.data) : this.data;
    const result = this.secret ? hmacSHA256(data, this.secretProvidedIsNotString ? hex.parse(this.secret) : this.secret) : sha256(data);
    return Buffer.from(result.toString(hex), 'hex');
  }
}
function castSourceData(toCast, encoding) {
  if (Buffer.isBuffer(toCast)) {
    return toCast;
  }
  if (typeof toCast === 'string') {
    return fromString(toCast, encoding);
  }
  if (ArrayBuffer.isView(toCast)) {
    return fromArrayBuffer(toCast.buffer, toCast.byteOffset, toCast.byteLength);
  }
  return fromArrayBuffer(toCast);
}
export const isArrayBuffer = arg => typeof ArrayBuffer === 'function' && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === '[object ArrayBuffer]';
export const fromArrayBuffer = (input, offset = 0, length = input.byteLength - offset) => {
  if (!isArrayBuffer(input)) {
    throw new TypeError(`The "input" argument must be ArrayBuffer. Received type ${typeof input} (${input})`);
  }
  return Buffer.from(input, offset, length);
};
export const fromString = (input, encoding) => {
  if (typeof input !== 'string') {
    throw new TypeError(`The "input" argument must be of type string. Received type ${typeof input} (${input})`);
  }
  return encoding ? Buffer.from(input, encoding) : Buffer.from(input);
};